"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RequestPatternModel = /** @class */ (function () {
    function RequestPatternModel(method, urlPattern) {
        this.method = method;
        this.urlPattern = urlPattern;
    }
    RequestPatternModel.prototype.match = function (request) {
        return request.method === this.method && this.matchPattern(request.url);
    };
    RequestPatternModel.prototype.matchPattern = function (url) {
        if (this.urlPattern instanceof RegExp) {
            return this.urlPattern.test(url);
        }
        return this.urlPattern.includes(url);
    };
    return RequestPatternModel;
}());
exports.RequestPatternModel = RequestPatternModel;
//# sourceMappingURL=request-pattern.model.js.map